import { render, staticRenderFns } from "./OverSelect.vue?vue&type=template&id=1a39e484&scoped=true&"
import script from "./OverSelect.vue?vue&type=script&lang=js&"
export * from "./OverSelect.vue?vue&type=script&lang=js&"
import style0 from "./OverSelect.vue?vue&type=style&index=0&id=1a39e484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39e484",
  null
  
)

export default component.exports